import { MATOMO_SITE_ID, MATOMO_URL } from '@configs';
import { usePatientStore } from '@stores';
import { capitalizeFirstLetter, toPascalCase } from '@utils';

import { MatomoTrackEventParams, MatomoTrackPageParams } from './matomo.types';

const IS_ENV_DEFINED = MATOMO_URL && MATOMO_SITE_ID;

export const initMatomo = (): void => {
  window._paq = window._paq || [];

  if (!IS_ENV_DEFINED) return;
  window._paq.push(['trackPageView']);
  window._paq.push(['enableLinkTracking']);
  window._paq.push(['enableHeartBeatTimer']);

  (function () {
    const normalizedUrlBase =
      MATOMO_URL[MATOMO_URL.length - 1] !== '/' ? `${MATOMO_URL}/` : MATOMO_URL;
    window._paq.push(['setTrackerUrl', `${normalizedUrlBase}/matomo.php`]);
    window._paq.push(['setSiteId', MATOMO_SITE_ID]);

    const d = document;
    const g = d.createElement('script');
    const s = d.getElementsByTagName('script')[0];

    g.type = 'text/javascript';
    g.async = true;
    g.defer = true;
    g.src = `${normalizedUrlBase}/matomo.js`;
    s.parentNode?.insertBefore(g, s);
  })();
};

const setUserId = () => {
  const userUUID = usePatientStore.getState().patientInfo.uuid;
  if (userUUID) window._paq.push(['setUserId', userUUID]);
};

export const trackPageView = ({ title }: MatomoTrackPageParams): void => {
  if (!IS_ENV_DEFINED) return;

  const isConsentForTracking =
    usePatientStore.getState().patientInfo.isConsentForTracking;
  if (!isConsentForTracking) return;

  setUserId();
  const pascalCasedTitle = toPascalCase(title);
  window._paq.push(['setDocumentTitle', pascalCasedTitle]);
  window._paq.push(['trackPageView']);
};

export const trackEvent = ({
  category,
  action,
  name,
  dimension,
}: MatomoTrackEventParams): void => {
  if (!IS_ENV_DEFINED) return;

  const isConsentForTracking =
    usePatientStore.getState().patientInfo.isConsentForTracking;
  if (!isConsentForTracking) return;

  setUserId();
  window._paq.push([
    'trackEvent',
    category,
    capitalizeFirstLetter(action),
    name,
    '',
    { ...(dimension || {}) },
  ]);
};
